<template>
	<div
		class="group relative flex flex-col border border-dj-grey-light rounded-big transition-shadow"
		:class="{
			'hover:shadow-md ': hover,
			'shadow-md': elevate,
		}"
	>
		<slot>
			<div>
				<p class="p-12">
					It's a base card ...
					{{ hover ? "with hover" : "" }}
					{{ elevate ? "with elevatation" : "" }}
				</p>
			</div>
		</slot>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "DjCard",
	props: {
		hover: {
			type: Boolean,
			default: false,
		},
		elevate: {
			type: Boolean,
			default: false,
		},
	},
});
</script>
